import { Component, OnInit } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {LocaleService} from "../../../services/locale.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-next-congress-announcement',
  templateUrl: './next-congress-announcement.component.html',
  styleUrls: ['./next-congress-announcement.component.scss']
})
export class NextCongressAnnouncementComponent implements OnInit {
  locale: any;
  environment = environment;

  constructor(private localeService: LocaleService,public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.locale = this.localeService.currentLocale();
  }

}
